import type { DataTableHeader } from '@/utils/types/vuetify'

const contractorAddressHeaders: DataTableHeader[] = [
  { key: 'type', title: 'Тип', sortable: false },
  { key: 'value', title: 'Адреса', sortable: false },
  { key: 'actions', title: 'Дії', align: 'center', sortable: false },
]

const contractorPhoneHeaders: DataTableHeader[] = [
  { key: 'type', title: 'Тип', sortable: false },
  { key: 'value', title: 'Номер', sortable: false },
  { key: 'actions', title: 'Дії', align: 'center', sortable: false },
]

const contractorEmailHeaders: DataTableHeader[] = [
  { key: 'type', title: 'Тип', sortable: false },
  { key: 'value', title: 'Адреса', sortable: false },
  { key: 'actions', title: 'Дії', align: 'center', sortable: false },
]

const contractorDocumentLinksHeaders: DataTableHeader[] = [
  { key: 'name', title: 'Документ', sortable: false },
  { key: 'number', title: 'Номер', sortable: false },
  { key: 'status', title: 'Статус', sortable: false },
  { key: 'actions', title: 'Дії', align: 'center', sortable: false },
]

const contractorTaskLinksHeaders: DataTableHeader[] = [
  { key: 'topic', title: 'Завдання', sortable: false },
  { key: 'deadline', title: 'Дедлайн', sortable: false },
  { key: 'status', title: 'Статус', sortable: false },
  { key: 'actions', title: 'Дії', align: 'center', sortable: false },
]

const contractorDocTypeDocumentLinksHeaders: DataTableHeader[] = [
  { key: 'definition.name', title: 'Тип документа', sortable: false },
  { key: 'registrationNumber', title: 'Номер', sortable: false },
  { key: 'status', title: 'Статус', sortable: false },
  { key: 'actions', title: 'Дії', align: 'center', sortable: false },
]

export {
  contractorAddressHeaders,
  contractorPhoneHeaders,
  contractorEmailHeaders,
  contractorDocumentLinksHeaders,
  contractorTaskLinksHeaders,
  contractorDocTypeDocumentLinksHeaders,
}
